import {createReducer, on} from '@ngrx/store';
import * as PaperChatActions from './paper-chat.actions';
import {PaperChatFilterType, PaperChatWebsocketDTO} from '../dto/paper-chat';

export interface PaperChatState {
  messages: PaperChatWebsocketDTO[];
  filterType: PaperChatFilterType;
  connectedByProject: { [projectId: number]: boolean };
  errorByProject: { [projectId: number]: any };
}

export const initialState: PaperChatState = {
  messages: [],
  filterType: PaperChatFilterType.ALL,
  connectedByProject: {},
  errorByProject: {},
};

export const paperChatReducer = createReducer(
  initialState,
  // Connection Handling
  on(PaperChatActions.connectSuccess, (state, {projectId}) => ({
    ...state,
    connectedByProject: {
      ...state.connectedByProject,
      [projectId]: true,
    },
    messages: [],
    errorByProject: {
      ...state.errorByProject,
      [projectId]: null,
    },
  })),
  on(PaperChatActions.connectFailure, (state, {projectId, error}) => ({
    ...state,
    connectedByProject: {
      ...state.connectedByProject,
      [projectId]: false,
    },
    messages: [],
    errorByProject: {
      ...state.errorByProject,
      [projectId]: error,
    },
  })),

  // Message Handling
  on(PaperChatActions.receiveMessage, (state, {message}) => {
    const foundMessage: PaperChatWebsocketDTO = message;
    let newMessageText = foundMessage.message
    if (!foundMessage.message) {
      newMessageText = '';
    }
    const messageIndex = state.messages.findIndex(msg => msg.timestamp === foundMessage.timestamp);

    if (messageIndex === -1) {
      return {
        ...state,
        messages: [...state.messages, foundMessage],
      };
    }
    const newMessages = [...state.messages];
    const currentMessage = newMessages[messageIndex].message ?? "";
    newMessages[messageIndex] = {
      ...foundMessage,
      message: currentMessage + newMessageText
    };

    return {
      ...state,
      messages: newMessages,
    };
  }),

  // Disconnection Handling
  on(PaperChatActions.disconnectSuccess, (state, {projectId}) => ({
    ...state,
    messages: [],
    connectedByProject: {
      ...state.connectedByProject,
      [projectId]: false,
    },
  })),
  on(PaperChatActions.disconnectFailure, (state, {projectId, error}) => ({
    ...state,
    errorByProject: {
      ...state.errorByProject,
      [projectId]: error,
    },
  })),
  on(PaperChatActions.setChatFilterType, (state, {filterType}) => ({
    ...state,
    filterType: filterType,
  })),
);
